export default __webpack_public_path__ + "i18n/translation-vi.9169f7eb.json";